import { render, staticRenderFns } from "./Analysis.vue?vue&type=template&id=65b9003c&scoped=true&"
import script from "./Analysis.vue?vue&type=script&lang=tsx&"
export * from "./Analysis.vue?vue&type=script&lang=tsx&"
import style0 from "./Analysis.vue?vue&type=style&index=0&id=65b9003c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b9003c",
  null
  
)

export default component.exports